module.exports = __webpack_public_path__ + "img/traffic_ballon.4be2d547.png";